<mat-accordion class="flex column" style="flex: 1; box-sizing: border-box;" [multi]="multi">
  <mat-expansion-panel  class="flex blue-box" style="box-sizing: border-box; width: 100%;"
    *ngFor="let panel of panels; let i = index"
    [expanded]="panel.expanded && !panel.disabled"
    [disabled]="panel.disabled"
    (opened)="onPanelOpened(panel)"
    (closed)="onPanelClosed(panel)"
  >
    <mat-expansion-panel-header (click)="togglePanel(panel)">
      <mat-panel-description style="display: flex; flex: 1; justify-content: space-between;">
        <span style="font-weight: 600;">{{ panel.title }}</span>
        <mat-icon style="color: green !important;" *ngIf="panel.done">check_circle</mat-icon>
        <mat-icon style="color: #11B1EB !important;" *ngIf="!panel.disabled && !panel.done">label_important</mat-icon>
      </mat-panel-description>
      
    </mat-expansion-panel-header>

    <!-- This is where parent content will be projected -->
    <ng-container *ngIf="panel.contentTemplate" 
      [ngTemplateOutlet]="panel.contentTemplate"
      [ngTemplateOutletContext]="panel.context || {}">
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
